import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d66acf02"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("精选专题")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("专题详情")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!
  const _component_Card = _resolveComponent("Card")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["selectedtopics", _ctx.theme])
  }, [
    _createVNode(_component_a_breadcrumb, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_breadcrumb_item, null, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(_component_a_breadcrumb_item, null, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("h3", null, _toDisplayString(_ctx.groupName), 1),
    _createVNode(_component_a_spin, {
      tip: "加载中...",
      spinning: _ctx.loading
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Card, {
          gutter: 22,
          span: 6,
          courses: _ctx.list,
          onJumpToCourse: _ctx.gotoCourseDetail
        }, null, 8, ["courses", "onJumpToCourse"])
      ]),
      _: 1
    }, 8, ["spinning"])
  ], 2))
}